/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Sends an old address to the page that replaced it, inside the app.
 *
 * Installed Deskshare products still open a few pages of the old site. The
 * server answers them with a permanent redirect (nginx.conf); this route is the
 * same rule for a host that serves the app without that configuration, where
 * the address would otherwise be read as a product called "survey.aspx" and
 * show a load error.
 *
 * keepQuery carries the query string across: the uninstall survey's address
 * holds the product, version and build the uninstaller put there, and losing
 * them loses what the feedback is about. Without it the new page opens clean.
 * The history entry is replaced, so Back does not return to the old address.
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const LegacyRedirect: React.FC<{ to: string; keepQuery?: boolean }> = ({
  to,
  keepQuery,
}) => {
  const { search } = useLocation();
  return <Navigate to={keepQuery ? `${to}${search}` : to} replace />;
};

export default LegacyRedirect;
